import httpClient, { PromofyAuthHeaders } from "@/api/httpClient.ts";
import { AuthContextProps } from "@/providers/AuthProvider.tsx";
import { PromoType } from "@/types/global.ts";

const getProductType = (): PromoType =>
  window.location.pathname.includes("/f2p") ? PromoType.F2P : PromoType.CASINO;

export const recordPromoOpen = (context: AuthContextProps, promoId: string) => {
  const gatewayBaseURL = import.meta.env.VITE_WIDGET_GATEWAY_BASE_URL;

  return httpClient.post(
    `${gatewayBaseURL}/promo/${promoId}/open`,
    { productType: getProductType() },
    {
      headers: {
        ...PromofyAuthHeaders(context),
      },
    }
  );
};
